import { useAppSelector } from '../hooks/useAppSelector';
import * as userSlice from '../data/user.slice';
export const useLoggedInProviderId = (): number | null | undefined => {
  // This will return the id of the provider the logged in
  // user belongs to. If the user is not a provider it returns null.
  const user = useAppSelector(userSlice.selectUserInfo);
  return user?.transportationProviderID || null;
};
